module.exports = __webpack_public_path__ + "static/media/anim_empty_list.939e3123.gif";